"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_native_1 = require("react-native");
class Form extends React.Component {
    constructor() {
        super(...arguments);
        this.inputs = [];
        this.count = 0;
    }
    renderChildren(children, focusOn) {
        // Counter is reset so it does not have duplicate components
        this.count = 0;
        return React.Children.map(children, child => {
            if (!child || !child.props) {
                return;
            }
            if (child.props.children) {
                return React.cloneElement(child, Object.assign({}, child.props, { children: this.renderChildren(child.props.children, focusOn) }));
            }
            if (!focusOn.some(input => input === child.type)) {
                return child;
            }
            if (!child.props.editable && child.props.hasOwnProperty('editable')) {
                return child;
            }
            const realIndex = this.count;
            this.count++;
            return React.cloneElement(child, {
                onSubmitEditing: () => {
                    if (child.props.onSubmitEditing) {
                        child.props.onSubmitEditing();
                    }
                    else if (this.inputs[realIndex + 1]) {
                        this.inputs[realIndex + 1].focus();
                    }
                },
                inputRef: (ref) => (this.inputs[realIndex] = ref)
            });
        });
    }
    render() {
        let _a = this.props, { children, focusOn } = _a, props = __rest(_a, ["children", "focusOn"]);
        return React.createElement(react_native_1.View, Object.assign({}, props), this.renderChildren(children, focusOn));
    }
}
Form.defaultProps = {
    focusOn: [react_native_1.TextInput]
};
exports.Form = Form;
